import { Injectable, Inject } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import { switchMap, catchError } from "rxjs/operators";
import { OKTA_AUTH } from "@okta/okta-angular";
import OktaAuth from "@okta/okta-auth-js";
import { Router } from "@angular/router";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private router: Router,
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // TODO: Re-enable Okta auth when configured
    // Skip auth header entirely while Okta is disabled
    return next.handle(request);

    /* Original Okta auth interceptor code:
    // Skip adding auth header for Okta endpoints
    if (request.url.includes("okta.com")) {
      return next.handle(request);
    }

    return of(this.oktaAuth.getAccessToken()).pipe(
      switchMap((token) => {
        if (token) {
          const authRequest = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          });
          return next.handle(authRequest);
        }
        return next.handle(request);
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Token expired or invalid, redirect to login
          this.router.navigate(["/login"]);
        }
        return throwError(() => error);
      }),
    );
    */
  }
}
